/**
 * Copyright (c) 2023 Gitpod GmbH. All rights reserved.
 * Licensed under the GNU Affero General Public License (AGPL).
 * See License.AGPL.txt in the project root for license information.
 */

import { forwardRef, type PropsWithChildren } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/components/podkit/lib/cn";

type TextProps = PropsWithChildren<{
    id?: string;
    className?: string;
    muted?: boolean;
    asChild?: boolean;
    title?: string;
}>;

export const Text = forwardRef<HTMLParagraphElement, TextProps>(
    ({ id, className, muted, children, asChild, ...props }, ref) => {
        const Comp = asChild ? Slot : "p";

        return (
            <Comp
                ref={ref}
                id={id}
                className={cn(muted ? "text-content-tertiary" : "text-content-primary", className)}
                {...props}
            >
                {children}
            </Comp>
        );
    },
);
Text.displayName = "Text";
